import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// ROUTES
import App from './App';
import Login from './components/Login/Login';
import Logout from './Logout';
import PayinTransactions from './components/PayinTransactions/PayinTransactions';
import PayoutTransactions from './components/PayinTransactions/PayoutTransactions';
import SettlementTransactions from './components/PayinTransactions/SettlementTransactions';

// CSS
import './assets/css/index.css';
import Main from './components/Dashboard/Main';
import PayinRequest from './components/Requests/PayinRequest';
import PayoutRequest from './components/Requests/PayoutRequest';
import SettlementRequest from './components/Requests/SettlementRequest';
import ChangePassword from './components/Profile/ChangePassword';
import SubAccount from './components/SubAccount/SubAccount';
import DepositReport from './components/Reports/DepositReport';
import WithdrawReport from './components/Reports/WithdrawReport';
import SetAuth from './components/Login/SetAuth';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: '/login', element: <Login />
    },
    {
        path: '/verify', element: <SetAuth />
    },
    {
        path: '/logout', element: <Logout />
    },
    {
        element: <App />,
        children: [
            {
                path: "/", element: <Main />
            },
            {
                path: "/payin-transactions", element: <PayinTransactions />
            },
            {
                path: "/payout-transactions", element: <PayoutTransactions />
            },
            {
                path: "/settlement-transactions", element: <SettlementTransactions />
            },
            {
                path: "/payin-request", element: <PayinRequest />
            },
            {
                path: "/payout-request", element: <PayoutRequest />
            },
            {
                path: "/settlement-request", element: <SettlementRequest />
            },
            {
                path: "/change-password", element: <ChangePassword />
            },
            {
                path: "/sub-account", element: <SubAccount />
            },
            {
                path: "/deposit-report", element: <DepositReport />
            },
            {
                path: "/withdraw-report", element: <WithdrawReport />
            }
        ]
    }
]);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
